import moment from "jalali-moment";
import { digitsEnToFa } from "@persian-tools/persian-tools";

function groupByKey(array, key) {
  return array.reduce((hash, obj) => {
    if (obj[key] === undefined) return hash;
    return Object.assign(hash, {
      [moment(obj[key])
        .locale("fa")
        .format("YYYY/MM/DD")]: (
        hash[
          moment(obj[key])
            .locale("fa")
            .format("YYYY/MM/DD")
        ] || []
      ).concat(obj),
    });
  }, {});
}
const todayYYYYMMDD = () => {
  return moment(new Date())
    .locale("fa")
    .format("YYYY/MM/DD");
};
const todayText = (date) => {
  return todayYYYYMMDD() === date ? "امروز" : null;
};
const DayMonthFormat = (date) => {
  return digitsEnToFa(
    moment
      .from(date, "fa", "YYYY/MM/DD")
      .locale("fa")
      .format("dddd DD MMMM")
  );
};
const timeHHMM = (time) => {
  const date = moment.utc(time);
  return digitsEnToFa(date.local().format(" HH:mm"));

  // moment
  //   .from(time, "en")
  //   // .locale("fa")
  //   .format("hh:mm")
};
const userListTime = (time) => {
  const hhmm = moment
    .utc(time)
    .local()
    .format(" HH:mm");
  const yymmdd = moment(time)
    .locale("fa")
    .format("YYYY/MM/DD");
  return hhmm + " - " + yymmdd;
};

export {
  groupByKey,
  todayText,
  DayMonthFormat,
  todayYYYYMMDD,
  timeHHMM,
  userListTime,
};
